<script setup lang="ts">
import DynamicCoursePage from './components/course/DynamicCoursePage.vue'

// Get course ID from URL or default to 8
const getCourseId = (): number => {
  const urlParams = new URLSearchParams(window.location.search)
  const id = urlParams.get('id')
  return id ? parseInt(id, 10) : 8
}

const courseId = getCourseId()
</script>

<template>
  <div>
    <!-- Course Content -->
    <DynamicCoursePage :courseId="courseId" />
  </div>
</template>

<style scoped>
/* App wrapper styles if needed */
</style>
